import React from 'react';
import { NotFoundLogic } from './NotFoundLogic';

const NotFound = () => {
  return <NotFoundLogic />;
};

export default NotFound; 